import AdvertCard from "./AdvertCard";
import ChannelCard from "./ChannelCard";
import EpisodeCard from "./EpisodeCard";
import LiveCard from "./LiveCard";
import TVShowCard from "./TVShowCard";

export default function Card(props) {
  const { item } = props;
  if (!item) return null;
  return (
    <>
      {item.__typename === "EpisodeMeta" && <EpisodeCard {...props} />}
      {item.__typename === "LiveMeta" && <LiveCard {...props} />}
      {item.__typename === "Advert" && <AdvertCard {...props} />}
      {item.__typename === "ChannelMeta" && <ChannelCard {...props} />}
      {item.__typename === "TVShowMeta" && <TVShowCard {...props} />}
    </>
  );
}
